// extracted by mini-css-extract-plugin
module.exports = {"LandingScreen":"LandingScreen_LandingScreen__2ytmZ","Box":"LandingScreen_Box__1V1mi","ButtonContainer":"LandingScreen_ButtonContainer__1ejyE"};